import { LegalClientInvestmentPurposeAndNatureEntity } from 'api/types/entity';
import { TFunc } from 'libs/i18n';

import { InvestmentPurposeAndNatureFormType } from '../../forms/investmentPurposeAndNatureForm';

export const getInitialData = (
  t: TFunc,
  data: LegalClientInvestmentPurposeAndNatureEntity | undefined
) => {
  const values: InvestmentPurposeAndNatureFormType | undefined = data
    ? {
        otherInvestmentObjective: data.otherInvestmentObjective,
        otherPlannedServices: data.otherPlannedServices,
        investmentDuration: {
          label: t(
            `onboarding.investmentPurposeAndNature.investmentDuration.types.${data.investmentDuration}`
          ),
          value: data.investmentDuration,
        },
        investmentObjectives: data.investmentObjectives?.map((v) => ({
          label: t(
            `onboarding.investmentPurposeAndNature.investmentObjectives.types.${v}`
          ),
          value: v,
        })),
        plannedServices: data.plannedServices?.map((v) => ({
          label: t(
            `onboarding.investmentPurposeAndNature.plannedServices.types.${v}`
          ),
          value: v,
        })),
      }
    : undefined;

  return values;
};
